<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <card>
            <v-spacer/>

            <v-dialog
              v-model="dialog"
              persistent
              max-width="768px">
              <template v-slot:activator="{ on }">
                <v-layout>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <base-button
                      :color="color"
                      class="mb-2"
                      v-on="on">
                      New Product
                    </base-button>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <base-input
                      v-model="search"
                      :loading="loading"
                      label="Search"
                      placeholder="Search..."
                      hide-details/>
                  </v-flex>
                </v-layout>
              </template>
              <card>
                <v-container grid-list-md >
                  <v-layout wrap>
                    <v-flex
                      xs12
                      sm2
                      md2>
                      <base-input
                        v-model="editedItem.id"
                        :disabled="true"
                        required
                        label="Id"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm5
                      md5>
                      <base-input
                        v-model="editedItem.name"
                        required
                        label="Name" />
                    </v-flex>
                    <v-flex
                        xs12
                        sm12
                        md12>
                      <label class="control-label"> Description</label>
                      <textarea
                          v-model="editedItem.description"
                          required
                          rows="5"
                          maxlength="256"
                          class="form-control" />
                    </v-flex>
                    <v-flex
                        xs12
                        sm6
                        md6>
                      <base-input
                          v-model="editedItem.price"
                          type="number"
                          required
                          label="Price" />
                    </v-flex>
                    <v-flex
                        xs12
                        sm6
                        md6>
                        <label class="control-label">
                          Payment Type
                        </label>
                      <br />
                        <el-select
                            v-model="editedItem.type"
                            placeholder="Payment Type">
                          <el-option
                              label="One Time"
                              value="one-time">
                          </el-option>
                          <el-option
                              label="Recurring"
                              value="recurring">
                          </el-option>
                        </el-select>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md6>
                      <base-input
                        v-model="editedItem.display_order"
                        required
                        type="number"
                        label="Display Order" />
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md6>
                      <label class="control-label"> Active</label>
                      <base-checkbox
                        v-model="editedItem.active"
                      > Active </base-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-card-actions>
                  <base-button
                    @click="close">Cancel</base-button>

                  <v-spacer/>
                  <base-button
                    type="primary"
                    @click="save">Save</base-button>
                </v-card-actions>
              </card>
            </v-dialog>

            <v-data-table
              :headers="headers"
              :items="ProductList"
              :disable-initial-sort="true"
              :rows-per-page-items ="rowsAmount"
              :search="search"
              :light="false"
              class="table table-striped"
            >

              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr @click="editItem(props.item)">

                  <td>{{ props.item.id }}</td>
                  <td>
                    {{ props.item.name }}
                  </td>

                  <td>
                    {{ props.item.description }}
                  </td>
                  <td>
                    {{ props.item.price }}
                  </td>
                  <td>
                    {{ props.item.type }}
                  </td>

                  <td>
                    {{ props.item.display_order }}
                  </td>
                  <td> <v-icon v-if="props.item.active">check</v-icon></td>

                  <td class="justify-center ">
                    <i
                      class="tim-icons icon-pencil pointer"
                      @click="editItem(props.item)"/>
                    &nbsp;&nbsp;
                    <i
                      class="tim-icons icon-trash-simple pointer"
                      @click="deleteItem(props.item)"/>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import BaseButton from '@/components/BaseButton'

export default {
  components: { BaseButton },
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    pagination: {},
    ProductList: [

    ],
    loading: true,

    startCalendar: false,
    endCalendar: false,

    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
    dialog: false,
    search: '',
    headers: [
      {
        text: 'Id',
        value: 'id'
      },
      {
        text: 'Name',
        value: 'name'
      },
      {
        text: 'Description',
        value: 'description'
      },
      {
        text: 'Price',
        value: 'price'
      },
      {
        text: 'Type',
        value: 'type'
      },
      {
        text: 'Display Order',
        align: 'left',
        value: 'display_order'
      },
      {
        text: 'Active',
        value: 'active'
      },
      {
        text: 'Action',
        value: 'Action',
        sortable: false
      }
    ],
    editedIndex: -1,

    editedItem: {
      id: '',
      name: '',
      description: '',
      price: '',
      display_order: 0,
      type: "",
      active: true
    },
    defaultItem: {
      id: '',
      name: '',
      description: '',
      price: '',
      display_order: 0,
      type: "",
      active: true
    }
  }),

  computed: {
    ...mapState('app', ['color']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Product' : 'Edit Product'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  // called when page is created before dom
  created () {
    this.index()
    // this.$store.dispatch('autoRefreshToken')
    // .then(response => console.log(response))
    // .catch(error => console.log(error))
  },

  methods: {
    index () {
      this.$store.state.spinning = true
      let self = this
      axios.get('/products')
        .then(response => {
          self.ProductList = response.data
          self.$store.state.spinning = false
        })
        .catch(err => {
          if (err.response.status == '403') {
            this.showError('Unauthorized')
          } else {
            this.showError(JSON.stringify(err.response.data.errors))
          }
          self.$store.state.spinning = false
          console.log(err.response.data.errors)
        })
    },

    // object.assign fills in the empty object with the properties of item
    editItem (item, dbox = true) {
      this.editedIndex = this.ProductList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = dbox
    },

    callTableAction (item, endpoint, method) {
      let tableItem = this.editedItem
      this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
        .then((response) => this.saveInline())
        .catch(error => {
          console.log(error)
          this.cancelInline
        })
    },

    deleteItem (item) {
      const index = this.ProductList.indexOf(item)
      if (confirm('Are you sure you want to delete this item?')) {
        this.$store.state.spinning = true
        axios.delete('/products/' + item.id)
          .then((response) => {
            this.ProductList.splice(index, 1)
            this.deleteInline()
            this.close()
            this.$store.state.spinning = false
          }
          )
          .catch(error => {
            if (error.response.status == '403') {
              this.showError('Unauthorized')
            } else {
              this.showError(JSON.stringify(error.response.data.errors))
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      // update
      if (this.editedIndex !== -1) {
        this.$store.state.spinning = true
        axios.put('/products/' + this.editedItem.id, this.editedItem)
          .then((response) => {
            Object.assign(this.ProductList[this.editedIndex], response.data)
            this.saveInline()
            this.close()
            this.$store.state.spinning = false
          }
          )
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(JSON.stringify(error.response.data.errors))
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
      // create
      else {
        this.$store.state.spinning = true
        axios.post('/products', this.editedItem)
          .then((response) => {
            this.ProductList.unshift(response.data)
            this.saveInline()
            this.close()
            this.$store.state.spinning = false
          })
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(JSON.stringify(error.response.data.errors))
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
      }
    },
    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Product saved'
    },
    deleteInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Product deleted'
    },
    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    reset () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
</style>
